<template>
  <el-select
    v-model="gender"
    placeholder="Gender"
    class="flex-basis-grow"
    :clearable="true"
  >
    <el-option
      value="FEMALE"
      label="Female"
    />
    <el-option
      value="MALE"
      label="Male"
    />
    <el-option
      value="OTHER"
      label="Other"
    />
  </el-select>
</template>

<script>
export default {
  name: 'Gender',
  computed: {
    gender: {
      get() {
        return this.$store.getters['filters/gender']
      },
      set(value) {
        value = (value === '') ? null : value
        this.$store.commit('filters/gender', value)
      }
    }
  }
}
</script>
